import { useMutation } from "@tanstack/react-query";
import { SubscriptionExportRequestResponse, SubscriptionExportRequestRequest } from "api/models";
import { AxiosError } from "axios";
import { postSubscriptionExportRequest } from "../../api";
import { useSelectedShop } from "shared/hooks";
import { useDateRangeContext } from "../useDateRangeContext";

export const useSubscriptionExportRequest = () => {
  const { selectedShopId } = useSelectedShop();

  const { startDate, endDate } = useDateRangeContext();

  const {
    mutateAsync: exportSubscriptions,
    isLoading: loading,
    data,
    variables,
    reset
  } = useMutation<
    SubscriptionExportRequestResponse,
    AxiosError<{ message: string }>,
    SubscriptionExportRequestRequest
  >(postSubscriptionExportRequest);

  const exportRequestResult =
    variables &&
    variables.shopId === selectedShopId &&
    variables.startDate === startDate &&
    variables.endDate === endDate
      ? data
      : undefined;

  return {
    exportSubscriptions,
    loading,
    exportId: exportRequestResult?.exportId,
    reset
  };
};
